import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { RadioButtons } from "../../../../../Common/UI/Index";
import { getQuarterlyRadioOptions } from "../../GetDataSourceValues";
import { SchedulingModes } from "../../../CreateSchedule/redux/Types";
import "../Common/Style.scss";

export interface IQuaterlyConfigViewPropType {
  onFieldChange: (selectedItem: string) => void;
}

/**
 * Component will be rendered for quaterly recurrence type
 * Responsible for rendering the three quaterly radio buttons in UI
 */
const QuaterlyConfigView = (props: IQuaterlyConfigViewPropType): JSX.Element => {
  const { onFieldChange } = props;
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;
  const selectedValue = (recurrenceData?.month) ? recurrenceData?.month.toString() : "1";
  const disabledFields = scheduling.mode === SchedulingModes.VIEW;
  const options = getQuarterlyRadioOptions(disabledFields);
  return (
    <div className="ebt-quaterly-container" data-testid="quaterly-container">
      <RadioButtons
        data-testid="quaterly-radio"
        defaultValue={selectedValue}
        options={options}
        onClickEvent={onFieldChange}
        disableFields={disabledFields}
      />
    </div>);
};

export default QuaterlyConfigView;

